import React, { useState } from 'react'
import { FoundationsButton } from '../GenericComponents/button'
import { AppDispatch, RootState } from '../Redux/store'
import { useDispatch, useSelector } from 'react-redux'
import { MetadataDrillThruItem } from '../Redux/Admin_Tasks/MDSSlice'
import GenericTableforArrayofObjects from '../GenericComponents/GenericTableforArrayofObjects'
import { useTitleContext } from "../Hooks/useTitleContext";
import { onEnter } from '../GlobalMethods'


interface RowData {
    [key: string]: any
}

const MDSTool: React.FC = () => {
    // FP-9489 - UI | Create "Select Drillthruset tool page based on search"

    const { setTitle } = useTitleContext();
    setTitle("MDSTool");

    const [MdsName, setSearchTerm] = useState('')
    const dispatch: AppDispatch = useDispatch<AppDispatch>()
    const { items, status, error } = useSelector((state: RootState) => state.MDSTool)
    const FactGroup = ''
    const handleKeyPress = (event: any) => onEnter(event, () => handleSearch(event));

    
    const handleSearch = (e: React.FormEvent) => {
        e.preventDefault()
        dispatch(MetadataDrillThruItem(MdsName))
    }
    return (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
            <div className="header">MetadataDrillThru Configuration</div>
            <br />
            <br />
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <form style={{ display: 'flex', alignItems: 'center' }}>
                    <label htmlFor="search">Search: </label>
                    <input
                        type="text"
                        id="search"
                        name="search"
                        onKeyDown={handleKeyPress}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                    <FoundationsButton
                        buttonClasses="ui-button ui-corner-all ui-widget app-button"
                        id="searchbutton"
                        onClick={handleSearch}
                    >
                        Search
                    </FoundationsButton>
                </form>
                <div style={{ marginLeft: '30px' }}>-or-</div>
                <FoundationsButton
                    type="button"
                    buttonClasses="ui-button app-button"
                    customStyle={{ marginLeft: '30px' }}
                    id="addMetadata"
                >
                    Add New MetaData
                </FoundationsButton>
            </div>
            {status === 'loading' && <div>Loading...</div>}
            {error && <div>Error: {error}</div>}
            {status === 'succeeded' && items.length > 0 && (
                <GenericTableforArrayofObjects items={items} /> // generictable created for array object FP-9489
            )}
            {status === 'succeeded' && items.length === 0 && <div>No items found.</div>}
        </div>
    )
}

export default MDSTool
